/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBlogPostDetail = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M13 13h6v2h-6zm0 4h6v2h-6zm0-8h6v2h-6zm0-4h6v2h-6zM5 17h6v2H5z" />
      <path d="M2 2v20h20V2zm18 18H4V4h16z" />
      <path d="M11 5H5v6h6zM9 9H7V7h2zm-4 4h6v2H5z" />
    </g>
  </Icon>
);
export { SvgBlogPostDetail as BlogPostDetail };
